export default __webpack_public_path__ + "static/media/13.ef898daa.png";